import Cookies from 'js-cookie';
import * as React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';

import { updateSelectedModes } from '@app/store/actions/app.actions';

const ModesRadioButtonRaw = ({ searchModes = [] }) => {
	const dispatch = useDispatch();
	// eslint-disable-next-line @typescript-eslint/no-shadow
	const selectedModes = useSelector((state) => state.app.selectedModes);

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [selectedMode, setSelectedMode] = React.useState(
		searchModes?.find((mode) => mode.id === selectedModes[0]),
	);

	React.useEffect(() => {
		const newMode = searchModes.find((mode) => mode.id === selectedModes[0]);
		setSelectedMode(newMode || searchModes[0]);
	}, [searchModes, selectedModes]);

	const handleModeChange = (modeId) => {
		const newMode = searchModes.find((mode) => mode.id === modeId);
		setSelectedMode(newMode || searchModes[0]);
		dispatch(updateSelectedModes([modeId]));
		Cookies.set('selectedMode', newMode.id, { secure: true });
	};

	return (
		<div className="mobile-search-form__search-modes">
			{searchModes.map((mode) => (
				<div className="mobile-search-form__search-mode" key={mode.id}>
					<input
						type="radio"
						id={mode.id}
						name="search-mode"
						value={mode.id}
						checked={selectedModes.includes(mode.id)}
						onChange={() => handleModeChange(mode.id)}
					/>
					<label htmlFor={mode.id}>{mode.label}</label>
				</div>
			))}
		</div>
	);
};

const mapStateToProps = (state) => ({
	selectedModes: state.app.selectedModes,
});

const mapDispatchToProps = {
	updateSelectedModes,
};

export const ModesRadioButton = connect(
	mapStateToProps,
	mapDispatchToProps,
)(ModesRadioButtonRaw);
